import React, { useEffect, useState } from 'react'

import Immutable from 'immutable'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import {
  menuClosePropositionTileAction,
  trackCloseThePropositionTile,
  trackShowThePropositionTile,
} from 'routes/Menu/actions/menuRecipeDetails'
import { RecipeTileBridge } from 'routes/Menu/components/RecipeTile/RecipeTileBridge'
import { CollectionId } from 'routes/Menu/domains/collections/constants'
import { getHasClosedPropositionTile } from 'routes/Menu/selectors/menu'

import { useAuth } from '../../domains/auth/useAuth'
import { CTAToAllRecipes } from '../CTAToAllRecipes'
import { PropositionTile } from './PropositionTile'
import { buildTracker } from './recipeListTracking'
import { useTracking } from './useTracking'

import css from './RecipeList.css'

export const RecipeList = ({ recipes, currentCollectionId }) => {
  const dispatch = useDispatch()
  const track = useTracking()

  const { isAuthenticated } = useAuth()
  const isSkipThePropositionActive = useIsOptimizelyFeatureEnabled(
    'beetroots_skip_sell_the_proposition_page_enabled',
  )
  const hasClosedTile = useSelector(getHasClosedPropositionTile)

  const [isOnAllRecipesCategory, setIsOnAllRecipesCategory] = useState(
    currentCollectionId === CollectionId.AllRecipes,
  )
  const [showPropositionTile, setShowPropositionTile] = useState(
    isSkipThePropositionActive && !isAuthenticated && !hasClosedTile && isOnAllRecipesCategory,
  )

  useEffect(() => {
    const isOnAllRecipes = currentCollectionId === CollectionId.AllRecipes
    setIsOnAllRecipesCategory(isOnAllRecipes)
    setShowPropositionTile(
      isSkipThePropositionActive && !isAuthenticated && !hasClosedTile && isOnAllRecipes,
    )
  }, [currentCollectionId, isAuthenticated, isSkipThePropositionActive, hasClosedTile])

  useEffect(() => buildTracker({ recipes, currentCollectionId, track })(), [])

  useEffect(() => {
    if (showPropositionTile) {
      dispatch(trackShowThePropositionTile())
    }
    // there is no scenario in which we want to fire two tracking events
    // for showing the sell the proposition tile
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const closeTile = () => {
    setShowPropositionTile(false)
    dispatch(menuClosePropositionTileAction())
    dispatch(trackCloseThePropositionTile())
  }

  const renderPropositionTile = () => <PropositionTile onClose={closeTile} />

  return (
    <div className={css.threeTileRecipeList}>
      {showPropositionTile && renderPropositionTile()}
      {recipes.map((value) => (
        <React.Fragment key={value.reference}>
          <RecipeTileBridge
            recipeReference={value.reference}
            recipe={value.recipe}
            originalId={value.originalId}
            collectionId={currentCollectionId}
          />
        </React.Fragment>
      ))}
      <CTAToAllRecipes />
    </div>
  )
}

RecipeList.propTypes = {
  recipes: PropTypes.instanceOf(Immutable.List).isRequired,
  currentCollectionId: PropTypes.string.isRequired,
}
